import React from "react";
import { RequestTab } from "../../../components/admin/Dashboard/Request/RequestTab";
import FollowNewCom from '../../../components/admin/Dashboard/following/FollowNewCompanies';
function Request() {
  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          <RequestTab />
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col ppk">
          <FollowNewCom type="request"/>
        </div>
      </div>
    </>
  );
}

export default Request;
